var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyActivejobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-empty-activejobs",
    transform: "translate(-773 -303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(773 303)",
    fill: "#1a1b43",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783",
    transform: "translate(803 333)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1504",
    "data-name": "Rectangle 1504",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M55,8H49V7A5,5,0,0,0,39,7V8H19V7A5,5,0,0,0,9,7V8H3a2,2,0,0,0-2,2V52a2,2,0,0,0,2,2H55a2,2,0,0,0,2-2V10A2,2,0,0,0,55,8ZM43,7a1,1,0,0,1,2,0v8a1,1,0,0,1-2,0ZM13,7a1,1,0,0,1,2,0v8a1,1,0,0,1-2,0ZM53,50H5V12H9v3a5,5,0,0,0,10,0V12H39v3a5,5,0,0,0,10,0V12h4Z",
    transform: "translate(-1 -2)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M25.5,21.5a2,2,0,0,0-1.824,1.176A2,2,0,0,0,24.5,26.5h1a2,2,0,0,0,2-2v-1A2,2,0,0,0,25.5,21.5Z",
    transform: "translate(20.5 17.5)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M12.869,22h-1.79a2,2,0,0,0,0,4h1.79a2,2,0,1,0,0-4Z",
    transform: "translate(7.079 18)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M17.341,22H15.553a2,2,0,1,0,0,4h1.788a2,2,0,1,0,0-4Z",
    transform: "translate(11.553 18)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M21.816,22h-1.79a2,2,0,1,0,0,4h1.79a2,2,0,0,0,0-4Z",
    transform: "translate(16.026 18)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M8.824,22.676A2,2,0,0,0,5,23.5v1a2,2,0,0,0,2,2H8a2,2,0,0,0,.824-3.824Z",
    transform: "translate(3 17.5)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M7,22.832a2,2,0,0,0,2-2V19.056a2,2,0,0,0-4,0v1.776A2,2,0,0,0,7,22.832Z",
    transform: "translate(3 13.056)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M8,13H7a2,2,0,0,0-2,2v1a2,2,0,0,0,3.824.824A2,2,0,0,0,8,13Z",
    transform: "translate(3 9)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M12.869,13h-1.79a2,2,0,0,0,0,4h1.79a2,2,0,1,0,0-4Z",
    transform: "translate(7.079 9)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M21.816,13h-1.79a2,2,0,1,0,0,4h1.79a2,2,0,0,0,0-4Z",
    transform: "translate(16.026 9)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M17.341,13H15.553a2,2,0,1,0,0,4h1.788a2,2,0,1,0,0-4Z",
    transform: "translate(11.553 9)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M25.5,13h-1a2,2,0,0,0-.824,3.824A2,2,0,0,0,27.5,16V15A2,2,0,0,0,25.5,13Z",
    transform: "translate(20.5 9)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M25,17.056a2,2,0,0,0-2,2v1.776a2,2,0,0,0,4,0V19.056A2,2,0,0,0,25,17.056Z",
    transform: "translate(21 13.056)",
    fill: "#1a1b43"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyActivejobs);
export default __webpack_public_path__ + "static/media/icon-empty-activejobs.5b32e6c8f93a6f61b3b989fd77897d8d.svg";
export { ForwardRef as ReactComponent };